import { Category } from '@apis/index'
import {
  deletesvg,
  edit,
  outlinestore,
  switchOff,
  switchOn,
} from '@assets/icons'
import Svg from '@components/svg'
import Table from '@components/table'
import Wrapper from '@components/wrapper'
import useScrollToTop from '@hooks/useScrollToTop'
import { RootState } from '@store/index'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const CategoryList = () => {
  const scrollToTop = useScrollToTop()
  const navigate = useNavigate()
  const {
    data: categories,
    loading,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.categories)
  const [page, setPage] = useState(1)
  console.log(categories, 'fs')
  const columns = [
    { title: 'Category Title', key: 'title' },
    {
      title: 'Image',
      key: 'image',
      render: (item) => (
        <img
          src={`https://admin.tournaop.com/${item.image}`}
          alt={item.title}
          style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 6 }}
        />
      ),
    },
    {
      title: 'Type',
      key: 'type',
      render: (item) =>
        item.type === 'manual' ? 'Manual' : item.type === 'smm' ? 'SMM' : 'AllU',
    },
    { title: 'Field One', key: 'fieldOne' },
    { title: 'Field Two', key: 'fieldTwo' },
    { title: 'Order', key: 'order' },
    {
      title: 'Status',
      key: 'status',
      render: (item) => (
        <Svg
          src={item.status ? switchOn : switchOff}
          onClick={async () => {
            await Category.update({
              id: item.id,
              data: { status: !item.status },
              state: 'categories',
            })
          }}
        />
      ),
    },
  ]

  const data =
    categories?.map((cat) => ({
      id: cat.id,
      title: cat.name,
      image: cat.image,
      type: cat.type || 'manual',
      key: cat.key || '',
      fieldOne: cat.infos?.fields?.[0]?.name || '',
      fieldTwo: cat.infos?.fields?.[1]?.name || '',
      order: cat.order ?? 0,
      status: cat.status,
    })) || []

  const fetchCategories = async () => {
    try {
      await Category.list({ state: 'categories', params: { limit: 30, page } })
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchCategories()
  }, [])

  return (
    <Wrapper>
      <Table
        clientSearch
        loading={loading}
        searchKeys={['title']}
        text="Store Category List"
        pageControlled={page}
        onPageChange={setPage}
        itemsPerPage={30}
        icon={outlinestore}
        data={data}
        columns={columns}
        totalItems={totalItems}
        totalPages={totalPages}
        actions={[
          {
            key: 'edit',
            icon: edit,
            onClick: (item) => {
              navigate(`/admin/store-management/category/${item.id}`, {
                state: item,
              })
              scrollToTop()
            },
          },
          {
            key: 'delete',
            icon: deletesvg,
            onClick: (item) => {
              Category.remove({ state: 'categories', id: item.id })
            },
          },
        ]}
      />
    </Wrapper>
  )
}

export default CategoryList
